import axios from "axios";
import { Method_POST } from "../../../../service/api";

const EXCEL_EXPORT_URL = "/portal/rest/contador/ordem-servico/export/excel";

const REPORT_POR_SITUACAO = {
  Pendentes: 2,
  Processadas: 3,
};

/**
 * Busca ordens de serviço filtradas por situação (Pendentes/Processadas),
 * cliente e tipo, já paginadas.
 */
export async function buscarOrdensServico({ situacao, idCliente, tipo, pagina, tamanhoPagina }) {
  const payload = {
    ordemServico: {
      contato: { nome: idCliente },
      tipo: { nome: tipo || "TODOS" },
      situacao: { nome: situacao },
    },
    paginacao: {
      pagina,
      tamanho: tamanhoPagina,
    },
  };

  const response = await Method_POST("/ordem-servico/pesquisar", payload);

  return {
    lista: response?.ordensServico || [],
    total: response?.paginacao?.totalRegistros || 0,
  };
}

/**
 * Exporta ordens de serviço para Excel e dispara o download no navegador.
 * `situacao` é opcional: quando omitida, exporta com os filtros correntes
 * (busca livre); quando informada ("Pendentes"/"Processadas"/"Todos"),
 * exporta o relatório fechado daquela aba.
 */
export async function exportarOrdensServicoExcel({ idCliente = "", situacao = "", tipo = "TODOS" } = {}) {
  const params = {
    report: REPORT_POR_SITUACAO[situacao] ?? 0,
    termo: idCliente,
    situacao,
    filtro: tipo,
  };

  const response = await axios.get(EXCEL_EXPORT_URL, {
    params,
    withCredentials: true,
    responseType: "blob",
  });

  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", "ordens-servico.xlsx");
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
}
